import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Zap, Lock } from "lucide-react";
import { CtaButton, GlowOrb, PromoBadge } from "@/components/landing/primitives";
import PhoneMockup from "@/components/landing/PhoneMockup";

const TRUST = [
  { icon: ShieldCheck, label: "12 types de red flags" },
  { icon: Zap, label: "Rapport en 10 sec" },
  { icon: Lock, label: "100% privé & chiffré" },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-28 pb-20 md:pt-36 md:pb-28">
      <GlowOrb className="w-[520px] h-[520px] -top-40 right-[-120px]" color="#EC4899" opacity={0.22} />
      <GlowOrb className="w-[420px] h-[420px] top-40 -left-40" color="#8b5cf6" opacity={0.16} />

      <div className="max-w-6xl mx-auto px-5 sm:px-6 grid md:grid-cols-2 gap-12 md:gap-8 items-center">
        <div>
          <PromoBadge>3 analyses offertes</PromoBadge>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.03]">
            <span className="bg-gradient-to-br from-white via-white to-zinc-500 bg-clip-text text-transparent">
              Ton Docteur Love,
            </span>
            <br />
            <span className="bg-gradient-to-r from-pink-500 via-fuchsia-500 to-purple-500 bg-clip-text text-transparent">
              24/7.
            </span>
          </h1>
          <p className="mt-5 text-zinc-400 text-base sm:text-lg leading-relaxed max-w-lg">
            L'IA qui décode tes conversations, détecte les red flags et suit tes relations dans le temps.
            <span className="text-zinc-200"> Comme un psy, mais toujours dispo.</span>
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <CtaButton testid="hero-cta" event="lead">
              Analyser ma conv gratuitement <ArrowRight size={18} />
            </CtaButton>
            <Link
              to="/quiz"
              data-testid="hero-quiz-cta"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-zinc-700 bg-zinc-900/60 text-zinc-100 font-bold px-6 py-4 hover:border-pink-500/50 transition-colors"
            >
              🧠 Test d'attachement gratuit
            </Link>
          </div>
          <p className="mt-4 text-xs text-zinc-500">3 analyses offertes • Aucune carte requise • Installable en PWA</p>

          <div data-testid="hero-launch-promo" className="mt-4 inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-gradient-to-r from-amber-500/15 to-rose-500/10 px-4 py-2">
            <span className="text-sm">🚀</span>
            <span className="text-xs sm:text-sm font-semibold text-amber-200">
              Offre de lancement : Premium <span className="line-through text-zinc-500">9,90€</span> <span className="font-black text-white">4,90€</span>/mois
            </span>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
            {TRUST.map(({ icon: Icon, label }) => (
              <div key={label} className="flex items-center gap-2 text-xs text-zinc-400">
                <Icon size={15} className="text-pink-400" /> {label}
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
